var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "header header-003" },
    [
      _c("page-header-search"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "secondary-region" },
        [
          _c("b-container", [
            _c(
              "div",
              { staticClass: "navbar navbar-expand-lg" },
              [
                _c("content-creator", {
                  attrs: {
                    settings: _vm.getBlobContents("header-social-icons"),
                    permissions: _vm.contentCreatorPermissions,
                    "is-visible": _vm.editContentCreator,
                    filestore: _vm.fileStore,
                    name: "header-social-icons",
                    "allowed-widgets": "social-icons",
                  },
                  on: {
                    updateBlob: (data) =>
                      _vm.saveBlob("header-social-icons", data),
                  },
                }),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  { attrs: { id: "nav_collapse", "is-nav": "" } },
                  [
                    _c("user-actions", {
                      attrs: { "help-active": _vm.helpActive },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(_vm.mobilenavcomponent, { tag: "component" }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "primary-region" },
        [
          _c("b-container", [
            _c("div", { staticClass: "inner-container" }, [
              _c(
                "div",
                { staticClass: "primary-desktop nav-left" },
                [
                  _c(
                    "b-navbar",
                    {
                      class: _vm.desktopMenuDisplayPort,
                      attrs: { toggleable: "md" },
                    },
                    [_c("main-menu", { attrs: { "menu-style": "desktop" } })],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "logo-display" }, [
                _c(
                  "div",
                  { staticClass: "desktop-logo" },
                  [
                    _c(_vm.elementLogoComponent, {
                      tag: "component",
                      attrs: { logo: "desktop-logo" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mobile-logo" },
                  [
                    _c(_vm.elementLogoComponent, {
                      tag: "component",
                      attrs: { logo: "mobile-logo" },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "primary-desktop nav-right" },
                [
                  _c(
                    "b-navbar",
                    {
                      class: _vm.desktopMenuDisplayPort,
                      attrs: { toggleable: "md" },
                    },
                    [
                      _c("main-menu", {
                        attrs: {
                          "menu-style": "desktop",
                          "menu-name": "main-menu-2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }